module.exports = __webpack_public_path__ + "fonts/DINRoundPro-Bold.eot?60343b97";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINRoundPro-Bold.eot
// module id = 785
// module chunks = 0 1 2 3 4 5